import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
const cube = (props) => (
  <SvgIcon width="18" height="19.636" viewBox="0 0 18 19.636" {...props}>
    <path
      d="M10,0,1,4.909v9.925l9,4.8,9-4.8V4.962L10,0Zm6.472,5.438L10,8.889,3.563,5.375,10,1.866ZM2.636,6.734,9.182,10.3v7.042L2.636,13.853V6.734Zm8.182,10.612V10.309l6.545-3.493v7.036Z"
      transform="translate(-1)"
    />
  </SvgIcon>
);
export default cube;



// WEBPACK FOOTER //
// ./src/common/icons/Cube/index.tsx